export default __webpack_public_path__ + "static/media/0x-brand-white.1e8b474f.png";